import { MerchFlowCoreRange } from "@CommonApi/merchandise";
import { ResponseGetMerchflowsCategories } from "@CommonApi/merchflows/categories";
import { omniAtom } from "src/utils/atoms";

export interface ImportPlanogramsFromPsaModalData {
  name: string;
  goLiveDate: Date;
  deactivationDate: Date | null;
  notes: string;
  coreRange: MerchFlowCoreRange;
  availableCategories: ResponseGetMerchflowsCategories;
  category: string | null;
  subcategory: string | null;
}

export const importPlanogramsFromPsaModalDataAtom = omniAtom({
  prefix: "src/modals/importPlanogramsFromPsa",
  key: "data",
  value: null as null | ImportPlanogramsFromPsaModalData,
});
